var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"app-button",class:_vm.buttonClass,attrs:{"to":_vm.buttonLink}},[_vm._v(" "+_vm._s(_vm.buttonText)+" "),_c('img',{style:(_vm.iconStyle),attrs:{"src":_vm.buttonIcon,"alt":_vm.buttonIcon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }